import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { ApiCurrency } from '../api';
import { formatAmountInCurrency } from '../utils';

export const TotalPaymentRow = (props: {
  currency: ApiCurrency;
  amount: number;
  loyaltyAmount: number;
}) => {
  const { t } = useTranslation();

  return (
    <tfoot>
      <tr>
        <td></td>
        <td colSpan={8} style={{ textAlign: 'start' }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
            }}
          >
            {props.loyaltyAmount > 0 && (
              <Box
                sx={{
                  display: 'flex',
                  textAlign: 'start',
                }}
              >
                <Typography color="primary" mr={2}>
                  {t('totalPaymentRow.totalLoyalityAmount')}:
                </Typography>
                <Typography color="primary" sx={{ fontWeight: 'bold' }}>
                  {formatAmountInCurrency(
                    props.loyaltyAmount,
                    props.currency.code,
                  )}
                </Typography>
              </Box>
            )}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                textAlign: 'start',
              }}
            >
              <Typography mr={2}>
                {t('totalPaymentRow.totalAmount')}:
              </Typography>
              <Typography sx={{ fontWeight: 'bold' }}>
                {formatAmountInCurrency(
                  Math.ceil(props.amount * 100) / 100,
                  props.currency.code,
                )}
              </Typography>
            </Box>
          </Box>
        </td>
      </tr>
    </tfoot>
  );
};
